import React, { createContext, useState } from "react"
import { randomBytes } from "crypto"

const ThemeContext = createContext([{}, () => {}])

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(["light", "full"])

  return (
    <ThemeContext.Provider
      key={randomBytes(6).toString("hex")}
      value={[theme, setTheme]}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export { ThemeContext, ThemeProvider }
